import { helpers } from 'design-system';
/**
 * Before sending a base64 image to the server, we first need to trim the initial format
 * string that marks the encoding type. This method will basically remove the string
 * 'data:image{...};base64,' from any provided input.
 *
 * @param source - The source stream to convert
 */
export default function prepareBase64(source: string): string {
  if (helpers.isImage(source)) {
    return source.replace(/^data:image\/[a-z]+;base64,/, '');
  }
  return source.replace(/^data:application\/[a-z]+;base64,/, '');
}
